export const PORTAL_BASE = '/portal';
export const APP_OPEN_PATH = '/link/open';
export const APP_INVITE_PATH = '/link/invite';
export const APP_INVITE_CODE_PATH = '/link/invite/code';
